import script from "./CooperationPartnerAccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CooperationPartnerAccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./CooperationPartnerAccordionItem.vue?vue&type=style&index=0&id=d2cb5112&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2cb5112"]])

export default __exports__